import { createAction } from '@reduxjs/toolkit';
import { IHistoryPush } from 'reactApp/modules/router/router.types';

export const changeSearchHistory = createAction<IHistoryPush>('search/changeHistory');
